import { create } from 'zustand';
import { getInitialSearchState, prepareBookingParams } from '@/utils';
import {
  getDefaultGuests,
  makeGuestsValid,
  getDefaultRooms,
  makeRoomsValid,
} from '@/utils/guests';

const initialState = {
  date: { startDate: null, endDate: null },
  inexactStay: 0,
  guests: getDefaultGuests(),
  location: {
    name: '',
    type: '',
    id: '',
  },
  pets: false,
  price: { min: null, max: null },
  rooms: getDefaultRooms(),
  amenities: [],
  tab: null,
};

export const useListingSearchStore = create((set, get) => ({
  focusField: null,
  tab: initialState.tab,
  date: initialState.date,
  inexactStay: initialState.inexactStay,
  guests: initialState.guests,
  rooms: initialState.rooms,
  location: initialState.location,
  pets: initialState.pets,
  setRooms: (rooms = initialState.rooms) => {
    return set({
      rooms: makeRoomsValid({
        ...initialState.rooms,
        ...rooms,
      }),
    });
  },
  setGuests: (guests = initialState.guests) => {
    return set({
      guests: makeGuestsValid({
        ...initialState.guests,
        ...guests,
      }),
    });
  },
  incrementGuest: (item) =>
    set((state) => {
      return {
        guests: makeGuestsValid({
          ...state.guests,
          [item]: state.guests[item] + 1,
        }),
      };
    }),
  decrementGuest: (item) =>
    set((state) => {
      return {
        guests: makeGuestsValid({
          ...state.guests,
          [item]: state.guests[item] - 1,
        }),
      };
    }),
  togglePets: (value) =>
    set((state) => {
      return {
        pets: value ?? !state.pets,
      };
    }),
  setPrice: (price = initialState.price) => set({ price }),
  setAmenities: (amenities = initialState.amenities) => set({ amenities }),
  setDate: (date = initialState.date) => set({ date }),
  setInvalidField: (invalidField) => set({ invalidField }),
  setFocusField: (focusField) => set({ focusField }),
  setInexactStay: (inexactStay = initialState.inexactStay) =>
    set({ inexactStay }),
  setLocation: (location = initialState.location) => set({ location }),
  setSearchFromQuery: (query) => {
    if (!query || Object.keys(query).length === 0) {
      return;
    }

    const state = get();
    const searchState = getInitialSearchState(query);
    const params = prepareBookingParams(searchState);

    state.setInexactStay(params.dateFlexibility);
    state.setLocation(params.location);
    state.setGuests(params.guests);
    state.setRooms(params.rooms);
    state.togglePets(params.pets);
    state.setDate(params.dateRange);
    state.setPrice(params.price);
    state.setAmenities(params.amenities);
  },
  onReset: () => set(initialState),
}));
